import * as RDialog from '@radix-ui/react-dialog'
import {Button, XCloseIcon} from '@translated/babele-react'
import clsx from 'clsx'
import {forwardRef} from 'react'

const DialogContent = forwardRef<
  React.ElementRef<typeof RDialog.Content>,
  React.ComponentPropsWithoutRef<typeof RDialog.Content>
>(({className, children, ...props}, ref) => (
  <RDialog.DialogPortal>
    <RDialog.DialogOverlay className={'fixed inset-0 z-30 bg-neutral-1200/8'} />
    <RDialog.Content
      ref={ref}
      className={clsx(
        'fixed left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-30',
        'w-full max-w-xl border shadow-xl rounded-md p-8',
        'bg-neutral-25',
        'flex flex-col gap-4',
        className,
      )}
      {...props}
    >
      {children}
      <RDialog.Close className="absolute right-4 top-4" asChild>
        <Button aria-label="Close dialog" variant={{mode: 'ghost', size: 'xs'}}>
          <XCloseIcon />
        </Button>
      </RDialog.Close>
    </RDialog.Content>
  </RDialog.DialogPortal>
))
DialogContent.displayName = 'DialogContent'

const DialogTitle = forwardRef<
  React.ElementRef<typeof RDialog.Title>,
  React.ComponentPropsWithoutRef<typeof RDialog.Title>
>(({className, ...props}, ref) => (
  <RDialog.Title
    ref={ref}
    className={clsx('font-bold text-display-xs', className)}
    {...props}
  />
))
DialogTitle.displayName = 'DialogTitle'

const Dialog = RDialog.Root
const DialogTrigger = RDialog.Trigger

export {Dialog, DialogTrigger, DialogContent, DialogTitle}
